import axios from 'axios'
import authUser from '../wpApi/authUser'

const WPAPIPATH = '/wp-json/pmkino/v1'

const HTTPMethod = Object.freeze ({
    GET: 'GET',
	POST: 'POST',
	PUT: 'PUT'
})

const apiURL = Object.freeze ({
    PRINT_GET:                        WPAPIPATH + '/print-get',
    PRINT_UPDATE:                     WPAPIPATH + '/print-update'
})



const createHeader = params  => (
    Object.freeze ({
        ...params.token     && {'Authorization' : `Bearer ${params.token}` },
        ...params.multipart && {'Content-Type'  : 'multipart/form-data' },
        ...params.nonce     && {'X-WP-Nonce': params.nonce},
        'Pmclient-Session': authUser.getSessionToken()
    })
)

const createApiCallConfig = params => (
    Object.freeze ({
        ...params.baseURL       && { baseURL: params.baseURL + apiURL[params.apiEndpoint] },
        //...params.apiEndpoint   && { url: apiURL[params.apiEndpoint] },
        ...params.url           && { url: params.url},
        ...params.method        && { method: HTTPMethod[params.method] },
        ...params.params        && { params: params.params },
        ...params.data          && { data: params.data },
        ...params.headerParams  && { headers: createHeader(params.headerParams) },
        ...params.signal        && { signal: params.signal }
    })
)

const createApiCall = params => (
    axios(createApiCallConfig(params))
)

export default createApiCall
